import { InjectionToken } from '@angular/core';

export interface AppConstants {
  company: string;
  appName: string;
  byeMessage: string;
}

export const APP_CONSTANTS: AppConstants = {
  company: 'kits',
  appName: 'kokitotsos FTW',
  byeMessage: 'May the force be with you',
};

export const APP_CONSTANTS_TOKEN = new InjectionToken<AppConstants>('APP_CONSTANTS');
